/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Animal_Material_PctInputs */

const en_attribute_animal_material_pct = /** @type {(inputs: Attribute_Animal_Material_PctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animal material %`)
};

/**
* | output |
* | --- |
* | "Animal material %" |
*
* @param {Attribute_Animal_Material_PctInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_animal_material_pct = /** @type {((inputs?: Attribute_Animal_Material_PctInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Animal_Material_PctInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_animal_material_pct(inputs)
});